/**
 * Chess Square Component (Inline Styles)
 * Default export - uses inline styles
 */
import type { SquareProps } from "../../types";
import { isLightSquare } from "../../utils";
import { Piece } from "../piece";
import { SquareBase } from "./SquareBase";

export function Square(props: SquareProps) {
  const { file, rank, isSelected, isLegalMove, isCapture } = props;
  const isLight = isLightSquare(file, rank);

  const getBackgroundColor = (): string => {
    if (isSelected) return "var(--cn-chess-square-selected)";
    if (isCapture) return "var(--cn-chess-capture-ring)";
    if (isLegalMove) return "var(--cn-chess-move-dot)";
    return isLight
      ? "var(--cn-chess-square-light)"
      : "var(--cn-chess-square-dark)";
  };

  const containerStyle: React.CSSProperties = {
    width: "64px",
    height: "64px",
    backgroundColor: getBackgroundColor(),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    position: "relative",
  };

  const legalMoveStyle: React.CSSProperties = {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "var(--cn-chess-move-dot)",
  };

  return (
    <SquareBase
      {...props}
      renderPiece={(piece) => piece && <Piece piece={piece} />}
      style={containerStyle}
      legalMoveStyle={legalMoveStyle}
    />
  );
}
